import React from "react";
import SmallPost from '../Models/SmallPost';

class RecommendedPosts extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            // Props input.
            post: props.post,

            // Recommendation data directly from server or via fetch.
            recommendations: props.post.recommendations,

            // Should we fetch fresh data?
            shouldFetch: false,

            // Do not show until we have data.
            show: false,

            // Config for setting high vs low TTL based on post age.
            // Match these with config/recommendations.php settings.
            postLowTtlMaxAge: 360,
            lowTtl: 30,
            hightTtl: 360,
        }

        // Exit early if this component is not enabled for this brand.
        if (!this.isComponentEnabled()) {
            return;
        }

        const dateNow = new Date();

        // Determine what to do: show immidietly or try fetching recommendations.
        if (Array.isArray(this.state.recommendations) && this.state.recommendations.length > 0) {
            // Set max allowed cache TTL before considered stale.
            const cacheTtl = this.dateDiffInMinutes(new Date(this.state.post.date), dateNow) < this.state.postLowTtlMaxAge ? this.state.lowTtl : this.state.hightTtl;

            // Check if the data we recieved is fresh.
            if (this.dateDiffInMinutes(new Date(this.state.recommendations[0].updated_at), dateNow) < cacheTtl) {
                // Recommendations are fresh.
                this.state.show = true;
            } else {
                // Recommendations are stale.
                this.state.shouldFetch = true;
            }
        } else {
            // No recommendations recieved from server.
            this.state.shouldFetch = true;
        }
    }

    componentDidMount() {
        if (this.state.shouldFetch) {
            // Fetch updated recommendation data.
            axios.get(`/api/post/${this.state.post.id}/recommendations/`)
                .then(response => {
                    if (response.status === 200) {
                        this.state.recommendations = response.data;

                        if (this.state.recommendations.length > 0) {
                            this.state.show = true;
                        }
                    }
                })
                .catch(error => console.error(error)); 
        }
    }

    /**
     * Determine if this component is enabled for this brand.
     * @returns bool
     */
    isComponentEnabled() {
        const hostname = window.location.hostname.split('.');
        return hostname.length >= 2 && ['elle', 'femina', 'allas'].includes(hostname[1]);
    }

    /**
     * Get the diff of two dates in minutes.
     * 
     * @param {Date} date1 
     * @param {Date} date2 
     * @returns {int}
     */
    dateDiffInMinutes(date1, date2) {
        return Math.floor(Math.abs(date1 - date2) / 60000);
    }

    render() {
        if (this.state.show) {
            return (
                <React.Fragment>
                    <div className="recommended wings" data-cts-object-group="">
                        <div className="recommended_title">
                            <span>Mer från { window.blogTitle }</span>
                        </div>
                        <div className="row">
                        {this.state.recommendations.map((recommendation, index) => {
                            return <SmallPost
                                key={recommendation.id} data={recommendation.post}
                                attributes={{
                                    "data-cts-object-category": "recommendation_engine",
                                    "data-cts-object-name": recommendation.post.title,
                                    "data-cts-object-extra-info": JSON.stringify([{
                                        "model": recommendation.model,
                                        "priority": "pr1",
                                        "recommendation_type": recommendation.type,
                                    }]),
                                    "data-cts-object-url": `${window.location.protocol}//${window.location.hostname}${recommendation.post.url}`,
                                    "data-cts-object-placement": index + 1,
                                }}
                                className="cts-tracking-object"
                            />
                        })}
                        </div>
                    </div>
                </React.Fragment>
            );
        }
        return null;
    }
}

export default RecommendedPosts;